import * as Sentry from '@sentry/browser';
import React from 'react';
import { connect } from 'react-redux';
import AppRouter from '@/app/app-router';
import { GA_TRACKING_ID } from '@/config';
import * as errorSelectors from '@/error-boundaries/error-selectors';
import { ERROR_TYPES } from '@/error-boundaries/errors';
import * as userActions from '@/user/user-actions';
import * as userSelectors from '@/user/user-selectors';
import version from '@/version';
import { GlobalStyles } from './styles';

// Sentry reporting for localhost can be blocked/ignored by configuring Sentry in its dashboard UI
Sentry.init({
  dsn: 'https://4889224d861e487886d7869954a7431e@sentry.io/1825561',
  environment: window.location.hostname,
  release: `rentalscape@${version}`,
});
if (!window.location.hostname.includes('deckard.com')) {
  // When in develop disable Google analytics
  window[`ga-disable-${GA_TRACKING_ID}`] = true;
}

window.Sentry = Sentry;

// TODO: consider implemeting Observer pattern
/**
 * utility function for having AppComponent listen for specifc errors
 * and will bubble error up to error boundary if there is a match
 *
 * @param {*} errorStatus
 */
function checkForSubscribedErrors(errorStatus) {
  const { errorType } = errorStatus;
  switch (errorType) {
    case ERROR_TYPES.UnauthorizedException: {
      throw Error(ERROR_TYPES.UnauthorizedException);
    }
    default:
      throw Error(ERROR_TYPES.DefaultException);
  }
}

class AppComponent extends React.Component {
  constructor(props) {
    super(props);

    // used for preventing user from navigating out of the app using the history object
    window.history.pushState({ appEntry: true }, 'Rentalscape');

    this.props.initiateCognitoAuthSetup();
  }

  /* eslint-enable class-methods-use-this */
  render() {
    // Check for error state
    const { errorStatus } = this.props;
    if (errorStatus.errorState) {
      checkForSubscribedErrors(errorStatus);
    }
    if (this.props.isPreAuthenticationPhase) return null;
    return (
      <>
        <GlobalStyles />
        <AppRouter isAuthenticated={this.props.isAuthenticated} />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    isPreAuthenticationPhase: userSelectors.isPreAuthenticationPhase(state),
    isAuthenticated: userSelectors.isAuthenticated(state),
    errorStatus: errorSelectors.errorStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setIsAuthenticated: (cognitoUser) =>
      dispatch(userActions.setIsAuthenticated({ cognitoUser })),
    setIsPreAuthenticationPhase: (value) =>
      dispatch(userActions.setIsPreAuthenticationPhase({ value })),
    initiateCognitoAuthSetup: () =>
      dispatch(userActions.initiateCognitoAuthSetup()),
  };
}

const App = connect(mapStateToProps, mapDispatchToProps)(AppComponent);

export default App;
